import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindAll } from '@bibliocommons/utils-react';
import {
  InlineOverlay,
  InlineOverlayHeader,
  InlineOverlayFooter,
  InlineOverlayBody,
  InlineOverlayCloseButton
} from '@bibliocommons/base-inline-overlay';
import { PrimaryButton } from '@bibliocommons/deprecated-base-buttons';
import { Checkmark } from '@bibliocommons/deprecated-base-icons';
import BibBrief from 'app/components/shared/BibBrief';
import { bibShape } from '@bibliocommons/bc-prop-types';
import { GenericForm } from '@bibliocommons/shared-messages';

import { SHELF_NAMES } from 'app/constants/ShelfConstants';
import MessagingContainer from 'app/components/Messaging/MessagingContainer';
import CancelHoldShelfPrompt from '../../cancel-hold-shelf-prompt';

import '../styles/BaseCancelHoldWorkflowView.scss';

export class BaseCancelHoldWorkflowView extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      shelfState: {
        toAdd: false,
        name: SHELF_NAMES.FOR_LATER
      }
    };
    bindAll(this);
  }

  handleShelfPromptChange(newShelfState) {
    this.setState(state => ({
      shelfState: {
        ...state.shelfState,
        ...newShelfState
      }
    }));
  }

  handleCancelHold() {
    const { shelfState } = this.state;
    this.props.handleClose();
    this.props.handleCancelHold({ shelfState });
  }

  renderShelfPrompt() {
    if (this.props.showShelfPrompt && !this.props.done) {
      return <CancelHoldShelfPrompt handleChange={this.handleShelfPromptChange} {...this.state.shelfState} />;
    }

    return null;
  }

  renderTitle() {
    const { holdIds } = this.props;

    if (holdIds.size === 1) {
      return (
        <span>
          <FormattedMessage id="cancel_confirmation_hold_title" />
          ...
        </span>
      );
    }

    return <FormattedMessage id="cancel_confirmation_hold_batch_title" values={{ count: holdIds.size }} />;
  }

  renderBibInfo() {
    const { bibs, holdIds } = this.props;
    const bib = bibs.first();
    const showBrief = holdIds.size === 1 && bib;

    return showBrief && <BibBrief bib={bib} titleTag="h3" renderTitleAsLink={false} renderAuthorsAsLink={false} />;
  }

  renderFooter() {
    const { isLoading, done } = this.props;
    return (
      !done && (
        <InlineOverlayFooter>
          <div className="col-12 col-xs-12">
            <PrimaryButton
              className="pull-right"
              isLoading={isLoading}
              handleClick={this.handleCancelHold}
              data-test-id="confirm-cancel-hold"
            >
              <Checkmark color="#FFF" /> <FormattedMessage id="cancel_confirmation_hold_button_yes" />
            </PrimaryButton>
            <InlineOverlayCloseButton className="btn btn-link pull-right">
              <FormattedMessage id="button_nevermind_close" />
            </InlineOverlayCloseButton>
          </div>
        </InlineOverlayFooter>
      )
    );
  }

  renderMessagingContainer() {
    if (this.props.messagingId) {
      return (
        <MessagingContainer id={this.props.messagingId}>
          {messageOptions => <GenericForm {...messageOptions} duration={false} />}
        </MessagingContainer>
      );
    }

    return null;
  }

  render() {
    const { handleClose, testId } = this.props;
    return (
      <InlineOverlay handleClose={handleClose} testId={testId}>
        <InlineOverlayHeader>{this.renderTitle()}</InlineOverlayHeader>
        <InlineOverlayBody className="cp-base-cancel-hold-workflow-view">
          {this.renderMessagingContainer()}
          {this.renderBibInfo()}
          <FormattedMessage id="your_position_will_be_lost" />
          {this.renderShelfPrompt()}
        </InlineOverlayBody>
        {this.renderFooter()}
      </InlineOverlay>
    );
  }
}

BaseCancelHoldWorkflowView.propTypes = {
  handleCancelHold: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
  holdIds: ImmutablePropTypes.listOf(PropTypes.string),
  isLoading: PropTypes.bool,
  done: PropTypes.bool,
  showShelfPrompt: PropTypes.bool,
  bibs: ImmutablePropTypes.listOf(bibShape).isRequired,
  testId: PropTypes.string,
  messagingId: PropTypes.string
};

BaseCancelHoldWorkflowView.defaultProps = {
  showShelfPrompt: true
};

export default BaseCancelHoldWorkflowView;
